import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { router, routesPath } from '../../router'
import { FooterProps } from '../../components/Footer'
import { actions } from '../../redux'

export const useFooter = (): FooterProps => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  return {
    logo: {
      src: `${import.meta.env.BASE_URL}images/logo-bis.png`,
      alt: t('footer.logo.alt'),
      logoLink: router(routesPath.home),
    },
    disclaimer: {
      title: t('footer.disclaimer.title'),
      text: t('footer.disclaimer.text'),
    },
    contact: {
      title: t('footer.contact.title'),
      phone: t('footer.contact.phone'),
      address: t('footer.contact.address'),
      contactUsCta: {
        text: t('footer.contact.text.link'),
        href: t('footer.contact.text.link.href'),
        target: '_blank',
      },
    },
    product: {
      title: t('footer.product.title'),
      links: [
        {
          text: t('footer.product.link.text.declaration.interest'),
          href: t('footer.product.link.text.declaration.interest.href'),
        },
      ],
    },
    legal: {
      title: t('footer.legal.title'),
      cookiesSettings: {
        text: t('footer.legal.link.text.cookies'),
        onClick: () => dispatch(actions.app.openCookiesSettings()),
      },
      links: [
        {
          text: t('footer.legal.link.text.legal'),
          href: t('footer.legal.link.text.legal.href'),
        },
        {
          text: t('footer.legal.link.text.policy'),
          href: t('footer.legal.link.text.policy.href'),
        },
        {
          text: t('footer.legal.link.text.cgu'),
          href: t('footer.legal.link.text.cgu.href'),
        },
        // {
        //   text: t('footer.legal.link.text.cgv'),
        //   href: t('footer.legal.link.text.cgv.href'),
        // },
        // {
        //   text: t('footer.legal.link.text.cpv'),
        //   href: t('footer.legal.link.text.cpv.href'),
        // },
      ],
    },
  }
}
